"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _Styled = require("./Styled");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HelperText = function HelperText(_ref) {
  var status = _ref.status,
      message = _ref.message,
      floating = _ref.floating;
  var level = status === 'error' ? 'danger' : status;
  return message ? /*#__PURE__*/_react.default.createElement(_Styled.Span, {
    status: level,
    floating: floating
  }, message) : null;
};

HelperText.defaultProps = {
  status: 'primary',
  message: undefined,
  floating: false
};
HelperText.propTypes = {
  status: (0, _propTypes.oneOf)(['', 'success', 'warning', 'danger', 'error']),
  message: _propTypes.string,
  floating: _propTypes.bool
};
var _default = HelperText;
exports.default = _default;